<div fxLayout="row" class="dynamic-break row-content" [class.tile-weekend]="isWeekend" [class.bottom-border]="isLast">
    <div class="left-border flex-16">{{ dateAsString }}</div>
    <div class="flex-84" *ngIf="dayRep.timeCardReps.length !== 0" fxLayout="column">
        <div fxLayout="row" class="fxFill" *ngFor="let cardRep of dayRep.timeCardReps; trackBy: trackBy">
            <div class="left-border flex-12">{{ cardRep.hoursToInvoice }}</div>
            <div class="left-border flex-12">{{ cardRep.hoursNoInvoice }}</div>
            <div class="left-border right-border worklog-flex-76">{{ cardRep.assembledText }}</div>
        </div>
    </div>
    <div class="auto-height-flex-84" fxLayout="column" *ngIf="dayRep.timeCardReps.length === 0">
        <div fxLayout="row" class="fxFill">
            <div class="left-border flex-12"></div>
            <div class="left-border flex-12"></div>
            <div class="left-border right-border worklog-flex-76"></div>
        </div>
    </div>
</div>
